
import React from 'react';
import { Button } from "@/components/ui/button";
import { PlusCircle, RefreshCw } from "lucide-react";

interface GamesPageHeaderProps {
  openAddDialog: () => void;
  repairCovers?: () => void;
  repairing?: boolean;
}

export const GamesPageHeader: React.FC<GamesPageHeaderProps> = ({ 
  openAddDialog, 
  repairCovers,
  repairing = false 
}) => {
  return (
    <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-8">
      <div>
        <h1 className="text-3xl font-bold text-white mb-2">
          Gerenciar Jogos
        </h1>
        <p className="text-gray-400">
          Adicione, edite e gerencie os jogos disponíveis na plataforma.
        </p>
      </div>
      <div className="flex space-x-4 mt-4 md:mt-0">
        {repairCovers && (
          <Button 
            variant="outline" 
            size="sm"
            onClick={repairCovers}
            disabled={repairing}
            className="border-[#2A3749] text-[#00B6F0] hover:bg-[#1E293B]"
          >
            <RefreshCw className={`h-4 w-4 mr-2 ${repairing ? 'animate-spin' : ''}`} />
            Reparar Imagens
          </Button>
        )}
        <Button 
          onClick={openAddDialog}
          className="bg-[#00B6F0] hover:bg-[#0099cc] text-white"
        >
          <PlusCircle className="h-4 w-4 mr-2" />
          Adicionar Jogo
        </Button>
      </div>
    </div>
  );
};
